import { CollectionData } from '../types';

import { validators } from './validators';

export const validateCollections = (collections: CollectionData[]) => {
  const brokenList = collections.reduce((acc, collection) => {
    const validator = validators[collection.name];

    if (!validator) {
      return acc;
    }

    const items = collection.items
      // @ts-ignore
      .map((item) => ({ item, ...validator(item) }))
      .filter((item) => !item.valid)
      .map((item) => ({
        data: item.item,
        updateFields: item.fields,
      }));

    if (items.length) {
      // @ts-ignore
      acc.push({ name: collection.name, items });
    }

    return acc;
  }, []);

  return brokenList;
};
